import { render, staticRenderFns } from "./Uniforms.vue?vue&type=template&id=b8d2c2ba&scoped=true"
import script from "./Uniforms.vue?vue&type=script&lang=js"
export * from "./Uniforms.vue?vue&type=script&lang=js"
import style0 from "./Uniforms.vue?vue&type=style&index=0&id=b8d2c2ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8d2c2ba",
  null
  
)

export default component.exports